import { Component, HostListener, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { getResourceCategoryColoredIconPath, getResourceCategoryDisplayName } from "src/app/common/categoryUtils";
import { ResourceCategory } from "src/app/models/api/inventoryResource.model";
import { ISelectedFilters } from "src/app/models/filters/selectedFilters.interface";
import { FiltersQueryTransformer } from "src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer";
import { BeautifyDisplayStringPipe } from "src/app/pipes/beautify-display-string/beautify-display-string.pipe";

@Component({
    selector: "app-category-amount",
    templateUrl: "./category-amount.component.html",
    styleUrls: ["./category-amount.component.scss"],
})
export class CategoryAmountComponent {
    @Input() public resourcesAmount: number;
    @Input() public resourcesCategory: ResourceCategory;
    @Input() public filterOptions: ISelectedFilters;

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _beautifyDisplayStringPipe: BeautifyDisplayStringPipe,
    ) {}

    public categoryIcon = () => getResourceCategoryColoredIconPath(this.resourcesCategory);

    public goToInventoryPage() {
        const filtersQuery = FiltersQueryTransformer.transformToQuery(this.filterOptions) + ` category:${this.resourcesCategory}`;

        this._router.navigate(["inventory"], {
            relativeTo: this._activatedRoute.parent,
            queryParams: { q: filtersQuery },
            queryParamsHandling: "merge",
        });
    }

    @HostListener("click", ["$event"])
    public onClick = () => this.goToInventoryPage();

    public get pluralizedCategoryDisplayName(): string {
        let base = getResourceCategoryDisplayName(this.resourcesCategory, this._beautifyDisplayStringPipe);
        if (!base.endsWith("s")) {
            base += "s";
        }
        return base;
    }
}
